export default __webpack_public_path__ + "static/media/puzzle-piece.3b17226f.svg";